import { render, staticRenderFns } from "./BranchStaffDetails.vue?vue&type=template&id=4762a246&"
import script from "./BranchStaffDetails.vue?vue&type=script&lang=js&"
export * from "./BranchStaffDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4762a246')) {
      api.createRecord('4762a246', component.options)
    } else {
      api.reload('4762a246', component.options)
    }
    module.hot.accept("./BranchStaffDetails.vue?vue&type=template&id=4762a246&", function () {
      api.rerender('4762a246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/BranchStaffDetails.vue"
export default component.exports